const doc = [({"zh_tw":({"adminButtonHotelCheckIn":({"addGuest":"新增客人", "addRoom":"添加房間", "deleteGuest":"刪除訪客", "deleteRoom":"刪除客房", "setUpMembership":"設置會員資格"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;